import { render, staticRenderFns } from "./HeadingBlock.vue?vue&type=template&id=2d079f54&scoped=true&"
import script from "./HeadingBlock.vue?vue&type=script&lang=js&"
export * from "./HeadingBlock.vue?vue&type=script&lang=js&"
import style0 from "./HeadingBlock.vue?vue&type=style&index=0&id=2d079f54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d079f54",
  null
  
)

export default component.exports